import React, { useState } from "react";
import { supabase } from "../lib/supabase";
import { useLang } from "../context/LangContext";

export default function Login() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showGuestForm, setShowGuestForm] = useState(false);
  const [guestName, setGuestName] = useState("");
  const [guestWeight, setGuestWeight] = useState("");
  const [guestError, setGuestError] = useState("");

  const clearGuestSessionData = () => {
    localStorage.removeItem("guestFoodLogs");
    localStorage.removeItem("ddp-medications-guest");
    localStorage.removeItem("ddp-medication-history-guest");
    localStorage.removeItem("ddp-meal-reminders-guest");
    localStorage.removeItem("ddp-medication-notifications-guest");
    localStorage.removeItem("ddp-medication-notifications-fired-guest");
    localStorage.removeItem("ddp-meal-mixer-guest");
    localStorage.removeItem("ddp-ai-meal-draft-guest");
    localStorage.removeItem("ddp-saved-mixed-meals-guest");
    localStorage.removeItem("ddp-medications-undefined");
    localStorage.removeItem("ddp-medication-history-undefined");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      alert(error.message);
    } else {
      console.log("SESSION:", data);

      // 🔥 FORCE reload session
      window.location.replace("/dashboard");
    }

    setLoading(false);
  };

  const handleGuestSubmit = (e) => {
    e.preventDefault();

    const fullName = guestName.trim();
    const weightValue = guestWeight.trim();
    const numericWeight = Number(weightValue);

    if (!fullName) {
      setGuestError("Full name is required.");
      return;
    }

    if (!weightValue) {
      setGuestError("Weight is required.");
      return;
    }

    if (!Number.isFinite(numericWeight)) {
      setGuestError("Weight must be numeric.");
      return;
    }

    clearGuestSessionData();
    localStorage.setItem(
      "guestProfile",
      JSON.stringify({
        full_name: fullName,
        weight_kg: numericWeight,
        guest: true,
      })
    );
    localStorage.setItem("guestMode", "true");

    window.location.replace("/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground px-4">
      <div className="w-full max-w-md bento-card p-6">
        <h2 className="text-2xl font-bold mb-4">{t("login")}</h2>

        <form onSubmit={handleLogin} className="flex flex-col gap-4">
          <input
            type="email"
            placeholder={t("email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="p-3 rounded-lg border border-border bg-transparent"
          />

          <input
            type="password"
            placeholder={t("password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="p-3 rounded-lg border border-border bg-transparent"
          />

          <button
            type="submit"
            disabled={loading}
            className="btn-primary h-12 rounded-full"
          >
            {loading ? t("logging_in") : t("login")}
          </button>
        </form>

        <div className="mt-4 text-sm text-muted-foreground text-center">
          {t("no_account")}{" "}
          <a href="/register" className="text-primary">
            {t("register")}
          </a>
        </div>

        <div className="mt-5 border-t border-border pt-5">
          <button
            type="button"
            onClick={() => {
              setShowGuestForm((current) => !current);
              setGuestError("");
            }}
            className="w-full h-12 rounded-full border border-border bg-card hover:bg-muted"
          >
            Continue as Guest
          </button>

          {showGuestForm && (
            <form onSubmit={handleGuestSubmit} className="mt-4 flex flex-col gap-3">
              <input
                type="text"
                placeholder="Full Name"
                value={guestName}
                onChange={(e) => setGuestName(e.target.value)}
                className="p-3 rounded-lg border border-border bg-transparent"
              />

              <input
                type="text"
                inputMode="decimal"
                placeholder="Weight (kg)"
                value={guestWeight}
                onChange={(e) => setGuestWeight(e.target.value)}
                className="p-3 rounded-lg border border-border bg-transparent"
              />

              {guestError && (
                <p className="text-sm text-red-500 text-center">{guestError}</p>
              )}

              <button type="submit" className="btn-primary h-12 rounded-full">
                Continue
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
